import React from 'react';
import { emptyObject } from '@fabric-ui/utils';
import { Popper, PopperProps } from '@mui/material';

export function PopperComponent({ style = emptyObject, ...params }: PopperProps) {
  return <Popper {...params} style={{ ...style, minWidth: 'fit-content' }} placement="bottom-start" />;
}

export function SimplePopperComponent({
  disablePortal,
  anchorEl,
  style,
  open,
  placement = 'bottom-start',
  children,
  ...others
}: PopperProps) {
  return <div {...(others as any)}>{typeof children === 'function' ? children({ placement }) : children}</div>;
}
